import { ids } from '@icarros/theme-react';
import styled, { css } from 'styled-components';

interface ListItemModifierProps {
  isSingle?: boolean;
  hideNextSiblingOnDesk?: boolean;
}

export const EmptyDetailsWrapper = styled.div`
  padding-bottom: 100px;
  > div {
    &:nth-child(2) {
      margin-top: 16px;
      margin-bottom: 4px;
    }

    &:nth-child(3) {
      margin-bottom: 60px;
    }

    &:nth-child(4) {
      > div:empty {
        margin-top: 20px;
        margin-bottom: 28px;

        &:last-of-type {
          display: none;
        }
      }
      > div > div:nth-of-type(2) {
        margin-left: 0;
      }
      svg {
        width: 24px;
        height: 24px;
        & path {
          fill: ${ids.color.action.secondary.ids_color_action_secondary_base};
        }
      }
    }
  }
`;

export const MessageWrapper = styled.div`
  min-height: 100vh;
  > div {
    &:first-of-type {
      margin-top: 40px;
      margin-bottom: 4px;
    }
    &:nth-of-type(2) {
      margin-bottom: 44px;
    }
  }
`;

export const CardBaseModifier = styled.div`
  margin-top: 56px;
  > div {
    padding: 24px;
    width: 100%;
    flex-direction: column;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-bottom: 24px;
`;

export const CardBody = styled.div`
  margin-bottom: 44px;
`;

export const ListItemModifier = styled.div<ListItemModifierProps>`
  ${({ hideNextSiblingOnDesk }) =>
    hideNextSiblingOnDesk &&
    css`
      @media (min-width: 1366px) {
        > div {
          display: none;
        }
        & + div {
          display: none;
          visibility: hidden;
        }
      }
    `}

  > div,
  > button {
    width: 100%;
  }

  > button div {
    &:first-of-type {
      margin-left: 0;
      padding-left: 0;

      svg {
        width: 24px;
        height: 24px;
        & path {
          fill: ${ids.color.action.secondary.ids_color_action_secondary_base};
        }
      }
    }

    &:nth-of-type(2) {
      margin-left: 0;
    }
  }
  ${({ isSingle }) =>
    !isSingle &&
    css`
      &:last-of-type {
        > div {
          display: none;
        }
      }
    `}

  ${({ isSingle }) =>
    isSingle &&
    css`
      > div > div {
        margin-left: 0;
      }
    `}
`;
